<template>
  <div>
    <!-- Preset Buttons -->
    <div class="flex flex-wrap gap-2 mb-4">
      <button
        v-for="preset in maturityPresets"
        :key="preset.name"
        @click="applyPreset(preset.range)"
        :class="[
          'px-2 py-1 text-sm rounded transition-colors',
          isCurrentPreset(preset.range)
            ? 'bg-blue-500 text-white'
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200',
        ]"
      >
        {{ preset.name }}
      </button>
    </div>

    <div class="w-full px-2">
      <vue-slider
        :model-value="modelValue"
        @update:model-value="handleSliderChange"
        :min="0"
        :max="61"
        :interval="1"
        :process="true"
        :tooltip="'always'"
        :tooltip-formatter="formatTooltip"
      ></vue-slider>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

export default {
  name: 'MaturityConditionComponent',
  components: {
    VueSlider,
  },
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    let debounceTimer = null;

    const maturityPresets = [
      { name: '3개월', range: [0, 3] },
      { name: '6개월', range: [4, 6] },
      { name: '1년 이내', range: [0, 12] },
      { name: '1년~1.5년', range: [12, 18] },
      { name: '1.5년~2년', range: [18, 24] },
      { name: '2년~2.5년', range: [24, 30] },
      { name: '2.5년~3년', range: [30, 36] },
      { name: '3년~5년', range: [36, 60] },
      { name: '전체', range: [0, 61] },
    ];

    const isCurrentPreset = range => {
      return (
        props.modelValue[0] === range[0] && props.modelValue[1] === range[1]
      );
    };

    const applyPreset = range => {
      emit('update:modelValue', [...range]);
    };

    const formatTooltip = value => {
      if (value === 0) return 'MIN';
      if (value === 61) return 'MAX';
      const years = Math.floor(value / 12);
      const months = value % 12;
      if (years === 0) return `${months}M`;
      if (months === 0) return `${years}Y`;
      return `${years}Y ${months}M`;
    };

    const handleSliderChange = value => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      debounceTimer = setTimeout(() => {
        emit('update:modelValue', [value[0], value[1]]);
      }, 300);
    };

    return {
      maturityPresets,
      isCurrentPreset,
      applyPreset,
      formatTooltip,
      handleSliderChange,
    };
  },
};
</script>

<style scoped>
::v-deep .vue-slider {
  margin: 8px 0;
  padding-bottom: 24px;
}

::v-deep .vue-slider-dot-tooltip {
  opacity: 1 !important;
  top: 70% !important;
  bottom: auto !important;
}

::v-deep .vue-slider-dot-tooltip-inner {
  background-color: rgb(75 85 99);
  border-color: rgb(75 85 99);
  color: white;
  padding: 2px 6px;
  font-size: 12px;
  min-width: max-content;
  transform: translateY(8px);
}

::v-deep .vue-slider-dot-tooltip-inner::after {
  top: -4px;
  bottom: auto;
  border-top-color: transparent;
  border-bottom-color: rgb(75 85 99);
}

::v-deep .vue-slider-process {
  background-color: rgb(59 130 246);
}

::v-deep .vue-slider-dot-handle {
  border-color: rgb(59 130 246);
}

::v-deep .vue-slider-rail {
  background-color: rgb(229 231 235);
}

button {
  transition: all 0.2s;
}

button:active {
  transform: scale(0.98);
}
</style>
